import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Loader from 'components/atoms/loader';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  width: { lg: '700px', xs: '250px' },
  transform: 'translate(-50%, -50%)',
  bgcolor: '#292739',
  color: 'white',
  borderRadius: '25px',
  border: '2px solid #ddb930',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
};

const imgStyles = {
  width: '50px',
  height: '50px',
  alignSelf: 'center',
  marginBottom: '10px',
};

interface IBackstagePrompt {
  children: JSX.Element;
  loading: boolean;
  transaction: boolean;
  isPost?: boolean;
  claimTrial?: boolean;
}

export default function BackstagePrompt({
  children,
  loading,
  transaction,
  isPost,
  claimTrial,
}: IBackstagePrompt) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const user0 = require('assets/Profile/buku_default_avatar.png');

  useEffect(() => {
    if (!loading) handleClose();
  }, [loading]);

  useEffect(() => {
    if (claimTrial) setOpen(false);
  }, [claimTrial]);

  return (
    <div>
      <Button
        disabled={transaction || loading}
        onClick={!loading ? handleClose : handleOpen}
      >
        {children}
      </Button>
      <Modal
        open={open || loading}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img style={imgStyles} src={user0} alt="buku" />
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {isPost ? 'Content Purchase' : 'Subscription'}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Please check your metamask wallet to confirm the transaction before
            we can proceed.
          </Typography>
          <Loader size="2" sx={{ marginTop: '10px' }} />
        </Box>
      </Modal>
    </div>
  );
}
